<app-header></app-header>
<!-- Desktop/Tablet Header -->
<ng-template
  #desktopTabletHeader
  let-betterBuyViewModel="betterBuyViewModel"
  class="better-buys-header"
>
  <ion-row id="better-buys-header-desktop-title">
    <ion-col size="10.5">
      <div>
        <p
          class="better-buys-header-text"
          [ngClass]="platformService?.platformType === 'tablet' ? 'tablet' : ''"
        >
          {{'i18n.betterBuys.betterBuys' | translate | uppercase }}
        </p>
      </div>
    </ion-col>
    <ion-col size="1.5">
      <div class="interaction-icons">
        <ion-label
          (click)="handleDownload(betterBuyViewModel.productConversionContainers)"
        >
          <ion-icon name="download-outline"></ion-icon>
          {{ 'i18n.common.download' | translate }}
        </ion-label>
        <ion-label
          (click)="handlePrint(betterBuyViewModel.productConversionContainers)"
        >
          <ion-icon name="print-outline"></ion-icon>
          {{ 'i18n.common.print' | translate }}
        </ion-label>
      </div>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <div id="better-buys-header-desktop">
        <div
          class="better-buys-info-container"
          [ngClass]="platformService?.platformType === 'tablet' ? 'tablet' : ''"
        >
          <div
            class="better-buy-product-count"
            [ngClass]="platformService?.platformType === 'tablet' ? 'tablet' : ''"
          >
            <span>
              <p
                class="count count-remaining"
                [ngClass]="platformService?.platformType === 'tablet' ? 'tablet' : ''"
              >
                {{betterBuyViewModel?.remaining}}
              </p>
              <p class="count-description-text">
                {{'i18n.betterBuys.remaining' | translate }}
              </p>
            </span>
            <span>
              <p
                class="count count-accepted"
                [ngClass]="platformService?.platformType === 'tablet' ? 'tablet' : ''"
              >
                {{betterBuyViewModel?.accepted}}
              </p>
              <p class="count-description-text">
                {{'i18n.betterBuys.accepted' | translate }}
              </p>
            </span>
          </div>
          <div class="better-buys-savings-breakdown-info-container">
            <div
              class="better-buys-saving-breakdown-banner-text"
              [ngClass]="platformService?.platformType === 'tablet' ? 'tablet' : ''"
            >
              {{'i18n.betterBuys.savingsBreakdown' | translate }}
            </div>

            <div>
              <div
                class="savings-breakdown-container"
                [ngClass]="platformService?.platformType === 'tablet' ? 'tablet' : ''"
              >
                <div
                  class="savings-breakdown-labels"
                  [ngClass]="platformService?.platformType === 'tablet' ? 'tablet' : ''"
                >
                  <p class="savings-total">
                    {{(totalAnnualSavings$ | async) | currency}}
                  </p>
                  <p class="savings-label">
                    {{'i18n.betterBuys.estimatedYearlySavings' | translate }}
                  </p>
                </div>
                <div class="savings-breakdown">
                  <div>
                    <p class="savings-breakdown-label">
                      {{'i18n.betterBuys.todaysEstSavings' | translate }}
                    </p>
                    <p class="savings-breakdown-label">
                      {{'i18n.betterBuys.yearToDateSavings' | translate }}
                    </p>
                    <p class="savings-breakdown-label">
                      {{'i18n.betterBuys.allTimeSavings' | translate }}
                    </p>
                  </div>
                  <div>
                    <p class="savings-breakdown-amount">
                      {{(estimatedTodaySavings$ | async) | currency}}
                    </p>
                    <p class="savings-breakdown-amount">
                      {{(estimatedYearToDateSavings$ | async) | currency}}
                    </p>
                    <p class="savings-breakdown-amount">
                      {{(estimatedAllTimeSavings$ | async) | currency}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ion-col>
  </ion-row>
</ng-template>
<!-- Mobile Header -->
<ng-template
  #mobileHeader
  let-betterBuyViewModel="betterBuyViewModel"
  class="better-buys-header-mobile"
>
  <ion-row>
    <ion-col size="10">
      <div id="better-buys-header-mobile-title">
        <p class="better-buys-header-text">
          {{'i18n.betterBuys.betterBuys' | translate }}
        </p>
      </div>
    </ion-col>
    <ion-col size="2">
      <div
        data-cy="better-buys-title-ellipsis-section"
        class="ellipsis-container"
      >
        <ion-icon
          data-cy="better-buys-title-ellipsis-icon"
          name="ellipsis-vertical"
          (click)="handleMobileEllipsis(betterBuyViewModel.productConversionContainers)"
        ></ion-icon>
      </div>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <div id="better-buys-header-mobile">
        <div class="better-buys-info-container">
          <div class="better-buys-savings-breakdown-info-container">
            <div>
              <div class="savings-breakdown-container">
                <div class="savings-breakdown">
                  <div>
                    <p class="savings-label">
                      {{'i18n.betterBuys.estimatedYearlySavings' | translate }}
                    </p>
                    <p class="savings-breakdown-label">
                      {{'i18n.betterBuys.todaysEstSavings' | translate }}
                    </p>
                    <p class="savings-breakdown-label">
                      {{'i18n.betterBuys.yearToDateSavings' | translate }}
                    </p>
                    <p class="savings-breakdown-label">
                      {{'i18n.betterBuys.allTimeSavings' | translate }}
                    </p>
                  </div>
                  <div>
                    <p class="savings-total">
                      {{(totalAnnualSavings$ | async) | currency}}
                    </p>
                    <p class="savings-breakdown-amount">
                      {{(estimatedTodaySavings$ | async) | currency}}
                    </p>
                    <p class="savings-breakdown-amount">
                      {{(estimatedYearToDateSavings$ | async) | currency}}
                    </p>
                    <p class="savings-breakdown-amount">
                      {{(estimatedAllTimeSavings$ | async) | currency}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="better-buy-product-count">
              <div class="red-badge">
                <ion-badge mode="ios">
                  {{betterBuyViewModel?.remaining}}
                </ion-badge>
                <p class="count-description-text">
                  {{ 'i18n.betterBuys.remaining' | translate }}
                </p>
              </div>

              <div class="black-badge">
                <ion-badge mode="ios">
                  {{betterBuyViewModel?.accepted}}
                </ion-badge>
                <p class="count-description-text">
                  {{ 'i18n.betterBuys.accepted' | translate }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ion-col>
  </ion-row>
</ng-template>
<ion-content
  *ngIf="(betterBuysViewModelV2$ | async) as betterBuyViewModel"
  class="gray-content-bg"
>
  <div class="better-buys-header-container">
    <ion-grid>
      <ng-container
        *ngIf="platformService?.platformType !== platformService?.platformEnum?.mobile"
        [ngTemplateOutlet]="desktopTabletHeader"
        [ngTemplateOutletContext]="{ betterBuyViewModel: betterBuyViewModel }"
      >
      </ng-container>
      <ng-container
        *ngIf="platformService?.platformType === platformService?.platformEnum?.mobile"
        [ngTemplateOutlet]="mobileHeader"
        [ngTemplateOutletContext]="{ betterBuyViewModel: betterBuyViewModel }"
      >
      </ng-container>
    </ion-grid>
  </div>
  <app-product-conversion-container
    [platform]="platform"
    [isOnline]="betterBuyViewModel?.isOnline"
    [productConversionContainers]="betterBuyViewModel?.productConversionContainers"
    [showAcceptDeclineButtons]="true"
    [originalProductTitle]="'i18n.betterBuys.currentProduct'"
    [pricingDisabled]="betterBuyViewModel?.pricingDisabled"
    (changeQuantityEmitter)="changeQuantityHandler($event)"
    (productImageClickEmitter)="handleProductImageClick($event)"
    (acceptSwapEmitter)="acceptSwap($event)"
    (declineSwapEmitter)="declineSwap($event)"
    (compareClickEmitter)="goToCompareProducts($event)"
  >
  </app-product-conversion-container>
  <app-footer></app-footer>
</ion-content>
